import LeftArrowIcon from "@public/images/leftArrowGarageName.svg";
import RightArrowIcon from "@public/images/rightArrowGarageName.svg";
import { Container, FlexContainer, GarageNameText, PlansBox } from "./styles";

export const PlansBoxContainer = (props: any) => {
    const { is_visible, id, topNudge } = props;
    if (!is_visible) return null;
    return (
        <Container>
            {topNudge && <FlexContainer>
                <LeftArrowIcon width={63} height={22} />

                <GarageNameText isVariant1={id === 'plans_top_banner1'}
                    isVariant2={id === 'plans_top_banner2'}
                    isVariant3={id === 'plans_top_banner3'}>{topNudge}</GarageNameText>
                <RightArrowIcon width={63} height={22} />
            </FlexContainer>}

            <PlansBox {...props} />
        </Container>
    )
}
export default PlansBoxContainer;